class PinyinService {

    $lv;
    Pinyin;

    constructor($lv) {
        this.$lv = $lv
    }

    /**
     * 将中文转换成拼音
     * @author  韦胜健
     * @date    2019/10/9 15:36
     * @param   chinese 中文
     * @param   option  转换参数，详情见：https://github.com/hotoo/pinyin
     */
    async pinyin(chinese, option) {
        if (!this.Pinyin) this.Pinyin = await this.getPinyinPlugin()

        /**
         * 默认参数
         * @author  韦胜健
         * @date    2019/10/9 15:37
         */
        const defaultOption = {style: this.Pinyin.STYLE_NORMAL,}                 //普通风格，默认不带声调
        const ret = this.Pinyin(chinese, Object.assign({}, defaultOption, option))
        return ret.map(([p]) => p).join('')
    }

    /**
     * 获取插件对象
     * @author  韦胜健
     * @date    2019/10/9 16:17
     */
    async getPinyinPlugin() {
        return await this.$lv.resource.loadLib('pinyin')
    }
}

export {PinyinService}